var period = 1; // 有効期限日数

$(function() {
   if($.cookie('access_1') == undefined && $('body.home')[0]) {
      $.cookie('access_1', 'on', { expires: period });
      $('#loadingLogo').css('display','block');
      new Vivus('loadingLogo', {
        duration: 100 ,
        start: 'autostart',
        pathTimingFunction: Vivus.EASE_OUT,},
        function(obj){
          $('#loadingLogo').addClass('fill');
          setTimeout(function(){
            $('#loadingLogo').fadeOut(function(){
              $('.loading-wrap').fadeOut();
            });
          },1000);
        }
      );
   } else {
    $('.loading-wrap').hide();
   }
});

$(function() {
  if($('#notFound')[0]){
    console.log('notFound');
    new Vivus('notFound', {
      duration: 100 ,
      start: 'autostart',
      pathTimingFunction: Vivus.EASE_OUT,},
      function(obj){
        $('#notFound').addClass('fill');
      }
    );
  }
});



$(function() {
  'use strict';
  var masonySetting = {
    masonryWrap: $('#worksList'),
    masonryItems: '.works',
    loadingItem: '.loaderSymbol' // ローダー用のCSSセレクタ
  };
  var　$container = masonySetting.masonryWrap;
  $container.masonry({
    columnWidth: '#tile_w',	// 整列用基本カラム幅をCSSセレクタで指定
    itemSelector: masonySetting.masonryItems,	// カラムのCSSセレクタ
    percentPosition: true,
    gutter: '#tile_margin'
  });


  var Loader = {
    init: function(){
      var _sel = masonySetting.loadingItem;
    },
    destroy: function(){
      $(masonySetting.loadingItem).fadeOut(500,
        function(){
          $(this).remove();
          revealItems();
        });
    }
  };
  Loader.init();
  $container.imagesLoaded().done(function(){
    // 画像読み込み完了
    setTimeout(function(){
      Loader.destroy();
    },100);
  });
  function revealItems(){
    var _elmes, _items;
    _elmes = $container.masonry('getItemElements'),
    _items = $container.masonry( 'getItems', _elmes );

    $container.children().css({
      visibility: 'visible'
      });
    $container.fadeIn().masonry('reveal', _items).masonry();
  }
  function replaceString(_str, _bf, _af, _flg){
    var _reg = new RegExp(_bf, _flg || '');
    return _str.replace(_reg, _af || '');
  }
});

(function () {
  var $imageSlider      = $('#detailImageList');
  var $imageSliderThumb = $('#thumbWrap');
  if($imageSlider[0]){
    imageSliderFunc();
  }
  function imageSliderFunc(){
    $imageSliderThumb.append($imageSlider.contents().clone());
    $imageSlider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      fade: true,
      arrows: false,
      swipe: false,
      asNavFor: '#thumbWrap' //サムネイルのクラス名

    });
    $imageSliderThumb.slick({
      infinite: true,
      slidesToShow: 8,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: '#detailImageList', //スライダー本体のクラス名
      focusOnSelect: true,
      swipe: false,
      responsive: [{
        infinite: true,
        breakpoint: 768,
        settings: {
          slidesToShow: 5
        }
      }]
    });

    //メインの画像スライダーサイズ調整
    var $sliderTargetLi = $('#detailImageList li');
    var $sliderTargetImage = $('#detailImageList li img');
    function mainSliderResize(){
      var ww = $(window).width();
      var wrapW = $('#detailImageList').width();
      if(ww < 768){
        $sliderTargetLi.css('height',ww);
        $sliderTargetImage.css('max-height',ww);        
      }else{
        $sliderTargetLi.css('height',wrapW);
        $sliderTargetImage.css('max-height',wrapW);                
      }
    }
    //スライダーのサムネイル画像部分サイズ調整
    var $sliderTumbTargetImage = $('#thumbWrap li img');
    var $sliderTumbTargetSpan  = $('#thumbWrap li span');
    function tumbSliderResize(){
      var w = $sliderTumbTargetImage[0].parentElement.clientWidth
      $sliderTumbTargetImage.css('max-height',w);
      $sliderTumbTargetSpan.css('height',w);
    }
    function tumbSliderResize_2(){
      var w = $sliderTumbTargetImage[0].parentElement.clientWidth
      if($(window).width() > 768){
        w = 76;

        console.log('76');
      }
      $sliderTumbTargetImage.css('max-height',w);
      $sliderTumbTargetSpan.css('height',w);
    }

    $(window).on('load', function() {
      mainSliderResize();
      tumbSliderResize_2();
    });      
    
    $(window).on('resize', function() {
      mainSliderResize();
      tumbSliderResize();
    });
  }



  var relatedSlick = null;
  var resizeTimer = null;
  $(window).on('resize load', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if($(window).width() < 768){
        if(relatedSlick == null){
          relatedSlickFunc();
        }
        relatedWidthReset();
      }else{
        if(relatedSlick != null){
          relatedSlick.slick('unslick');
          relatedSlick = null;
        }
        relatedWidthSet();
      }
    }, 100);
  });
  function relatedWidthSet(){
    var target = $('.related-works-list li .image-wrap');
    var targetImage = $('.related-works-list li .image-wrap img');
    var w =  $('.related-works-list li').width();
    // console.dir(w);
    target.css('height',w);
    targetImage.css('max-width',w);
  }
  function relatedWidthReset(){
    var target = $('.related-works-list li .image-wrap');
    var targetImage = $('.related-works-list li .image-wrap img');
    target.css('height','');
    targetImage.css('max-width','');
  }
  
  function relatedSlickFunc(){
    relatedSlick = $('.related-works-list').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      focusOnSelect: false,
      centerMode: false,
      centerPadding: '20px',
      mobileFirst: true,
      responsive: [{
        breakpoint: 374,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
      },]
    });
  }
}());


// ------------------------------------
//	Smooth Scroll Settings
// ------------------------------------
(function () {
  var target = $("html, body");
  var move = function(targetPos, hash){
    target.animate({scrollTop: targetPos}, 400, function(){
      window.location.hash = hash;
    });
  };
  $(document).on("click", "a[href^=\"#\"]", function(e){
    e.preventDefault();
    var target = $(this).attr("href").split('#')[1];
    if(target == ""){
      move(0, target);
    }else if($("#" + target).length > 0){
      var targetPos = $("#" + target).offset().top;
      move(targetPos, target);
    };
  });
}());



// ------------------------------------
if($('.company-info-fix')[0]){
    companyInfoFixed();
}

function companyInfoFixed() {
  var fixedTarget = $('.company-info-fix');
  $(window).on('load',function(){
    // setTimeout(function(){
      var contentWidth = $('.bottom-wrap').width();
      var companyW = $('.company-info').outerWidth();
      var companyH = $('.company-info').outerHeight();  
      fixedTarget.css({
        'width':contentWidth,
        'display':'none',
        'opacity': 1
      });
      $('#company-info-space').css('width',companyW).css('height',companyH);
      if($('.search-no-results')[0]){
        fixedTarget.removeClass('fixed').css('display','block');
      }  
    // },100);
  });
  $(window).on('resize',function(){
    var contentWidth = $('.bottom-wrap').width();
    var companyW = $('.company-info').outerWidth();
    var companyH = $('.company-info').outerHeight();
    fixedTarget.css('width',contentWidth);
    if(companyH){
      $('#company-info-space').css('width',companyW).css('height',companyH);
    }
  });
  $(window).on('scroll',function(){
    if(!$('.search-no-results')[0]){
      var fixedHeight = $('.bottom-wrap').height();
      var wh = $(window).height();
      var fh = $('.main-footer').outerHeight();
      var sc = $(this).scrollTop();
      var tp = $('.bottom-wrap').offset().top - wh + fixedHeight + 50;
      if(sc > wh/3){
        fixedTarget.fadeIn();
      }else{
        fixedTarget.fadeOut();
      }
      if(tp <= sc && fixedTarget.hasClass('fixed')){
        fixedTarget.removeClass('fixed');
      }else if(tp > sc && !fixedTarget.hasClass('fixed')){
        fixedTarget.addClass('fixed');
      }
    }
  });
}



//serach
if($('body.search')[0]){

  var arg = new Object;
  
  var pair=location.search.substring(1).split('&');  
  
  for(var i=0;pair[i];i++) {
      var kv = pair[i].split('=');// kvはkey-value
      arg[kv[0]]=kv[1];  // kv[0]がkey,kv[1]がvalue
  }
}

var QueryString = {
  parse: function(text, sep, eq, isDecode) {
    text = text || location.search.substr(1);
    sep = sep || '&';
    eq = eq || '=';
    var decode = (isDecode) ? decodeURIComponent : function(a) { return a; };
    return text.split(sep).reduce(function(obj, v) {
      var pair = v.split(eq);
      obj[pair[0]] = decode(pair[1]);
      return obj;
    }, {});
  },
  stringify: function(value, sep, eq, isEncode) {
    sep = sep || '&';
    eq = eq || '=';
    var encode = (isEncode) ? encodeURIComponent : function(a) { return a; };
    return Object.keys(value).map(function(key) {
      return key + eq + encode(value[key]);
    }).join(sep);
  },
};

(function () {
// $(window).on('load',function(){
  var searchQuery = QueryString.parse(null,null,null,true);
  //クエリをフォームにセット
  //キーワード
  if(searchQuery.s){
    console.log(searchQuery.s);
    $('input#s').val(searchQuery.s);
  }
  //価格下限
  if(searchQuery.cost_low){
    $('#costLow').val(searchQuery.cost_low);
  }else{
    $('#costLow').val(0);
  }
  //価格上限
  if(searchQuery.cost_high){
    $('#costHigh').val(searchQuery.cost_high);
  }else{
    $('#costHigh').val(99999999);
  }
  //サイズ縦
  $('#sizeH').val(searchQuery.size_h);
  //サイズ横
  $('#sizeW').val(searchQuery.size_w);
  //サイズ奥行き
  $('#sizeD').val(searchQuery.size_d);
  //種別
  $('#catnum').val(searchQuery.catnum);

// });

  if($('.no-result-text')[0]){
    $("body").addClass("search-no-results");
  }
}());



//サービスページ
(function () {
  $('.mv-logo-outer').css('display','block');
  if($('#mvLogo')[0]){
    new Vivus('mvLogo', {
      duration: 100 ,
      start: 'autostart',
      pathTimingFunction: Vivus.EASE_OUT,},
      function(obj){
        $('#mvLogo').addClass('fill');
        setTimeout(function(){
          $('.mv-bg-image').fadeIn(800);
        },1000);
      }
    );
  }
}());

$('#menuTrigger').on('click', function(){
  var $target = $('#gnav');
  if($(this).hasClass('is-active')){
    $(this).removeClass('is-active');
    $target.removeClass('is-active');
  }else{
    $(this).addClass('is-active');
    $target.addClass('is-active');
  }
})
$('.p_gnav-list li a').on('click', function(){
  $('#menuTrigger').trigger('click');
});


(function () {
  if($('#mvGraph')[0]){
    var stage = new PIXI.Container(),
        renderer = PIXI.autoDetectRenderer(500, 500, {transparent: true,antialias:true }),
        target = document.getElementById("mvGraph");
    target.appendChild(renderer.view);
    
    var circleSetting = {
      lineW : 1,
      color : "0xE5E5E5",
      alpha : 1
    }
    
    var circle_1 = new PIXI.Graphics();
    circle_1.lineStyle(circleSetting.lineW, circleSetting.color, circleSetting.alpha);
    circle_1.drawCircle(298, 300,200);
    circle_1.pivot.set(297);
    circle_1.position.set(250,250);
    stage.addChild(circle_1);
    
    var circle_2 = new PIXI.Graphics();
    circle_2.lineStyle(circleSetting.lineW, circleSetting.color, circleSetting.alpha);
    circle_2.drawCircle(305, 305,200);
    circle_2.pivot.set(300);
    circle_2.position.set(250,250);
    stage.addChild(circle_2);

    var circle_3 = new PIXI.Graphics();
    circle_3.lineStyle(circleSetting.lineW, circleSetting.color, circleSetting.alpha);
    circle_3.drawCircle(308, 302,200);
    circle_3.pivot.set(300);
    circle_3.position.set(250,250);
    stage.addChild(circle_3);

    var blurFilter = new PIXI.filters.BlurFilter();
    // stage.filters = [blurFilter];
    
    update();
    function update(){
      circle_1.rotation -= 0.01;
      circle_2.rotation += 0.012;
      circle_3.rotation += 0.008;
      renderer.render(stage);
      requestA = requestAnimationFrame(update);
    }


  }
}());


(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] ||
      window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function() {
          callback(currTime + timeToCall);
        },
        timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
}());

